import metadata from "./metadata.json";
export const DOMAIN_LABELS = metadata.domains.map(domain => domain.label);
export const SUMMARY_FIELDS = metadata.domains.map(domain => domain.summaryField);
export const formatScore = (score) => typeof score === "number" && Number.isFinite(score) && score >= 1 && score <= 5 ? `${score.toFixed(1)}/5` : "Not assessed";
export const normalizeAnswers = (raw, polarities) => {
  if (raw.length !== 5 || polarities.length !== 5 || raw.some(value => !Number.isInteger(value) || value < 1 || value > 5)) throw new Error("Five selected answers are required.");
  return raw.map((value, index) => polarities[index] === "Negative" ? 6 - value : value);
};
